<his-documentation-link
	[target]="moduleOptions.DOCUMENTATION_ARTICLE"
	[title]="moduleOptions.DOCUMENTATION_TITLE">
</his-documentation-link>

<div>
	<!-- delete confirmation dialog from common package -->
	<res-confirmation-dialog></res-confirmation-dialog>
	<!-- res information dialog - record can not be deleted due to connections in other objects -->
	<res-information-dialog></res-information-dialog>

	<his-search-result #SearchResultComponent
		[showTitle]="true"
		[showNewSearchButton]="true"
		jobStarterKey="fs.res.search-publication-reports"
		defaultActionRoute="/pub/view/:id"
		idColumn="Publication.id"
		defaultColumn="Publication.title"
		[searchConfigFile]="moduleOptions.SEARCH_CONFIGURATION_FILENAME"
		[resultListTemplate]="publicationService.showList ? resultListTemplate : null"> <!-- without this, the normal table is displayed -->

		<ng-container *ngIf="showBackButton" customResultButtons>
			<button (click)="navigationService.navigateToLastBackUrl()"><span>{{'common.back' | hisUi }}</span></button>
		</ng-container>

		<ng-template #resultListTemplate let-data let-firs="first" let-total="totalRecords" let-rows="rowsPerPage">
			<res-publication-search-result-list
                [data]="data"
                [compName]="'searchResultview'"
                [totalRecords]="total"
                [rowsPerPage]="rows"
                [first]="firs"
                [prevPage]="'pubSearch'"
				(page)="page($event)">
			</res-publication-search-result-list>
			<!-- [customActionButtonsTemplate]="duplicatesButtonTemplate" entfernt wegen #298789 -->
		</ng-template>

		<ng-container customResultButtonsAfterJobStarter>
			<button (click)="publicationService.switchListTable('searchResultview',null)" class="transparent">
				<img hisImage="TEXT_LIST_BULLETS" class="inlineicon" [title]=" ">
				<span>{{'psv.bau.plan.listenAnsicht' | hisUi}}</span>
			</button>
		</ng-container>

		<ng-template #rowAction let-row="row">
			<!-- edit "button": disabling needs some trickery because links do not support the disabled attribute -->
			<ng-container *ngIf="auth.hasAnyArray(moduleOptions.RIGHT_EDIT) || auth.hasAnyArray(moduleOptions.RIGHT_CHANGE)">
				<a *ngIf="row.get('canEdit')" (click)="onBeforeNavigate()" routerLink="/pub/edit/{{row.get('Publication.id')}}" [queryParams]="getEditlinkQueryParams()" hisImage="pencil"
				    title="{{'common.editOf'|hisUi:row.get('Publication.title')}}"></a>
				<a *ngIf="!row.get('canEdit')  && row.get('canRequestChange')" (click)="onBeforeNavigate()" routerLink="/pub/change-request/{{row.get('Publication.id')}}" [queryParams]="getEditlinkQueryParams()" hisImage="pencil"
				    title="{{'common.editOf'|hisUi:row.get('Publication.title')}}"></a>
				<img *ngIf="!row.get('canEdit') && !row.get('canRequestChange')" hisImage="pencil_i" class="inlineicon imggrey"
				    title="{{'common.editOf'|hisUi:row.get('Publication.title')}}">
			</ng-container>

            <!-- detail view -->
			<a (click)="onBeforeNavigate()" routerLink="/pub/view/{{row.get('Publication.id')}}" [queryParams]="getViewlinkQueryParams()"  hisImage="magnifier_detail"
            title="{{'common.showOf'|hisUi:row.get('Publication.title')}}"></a>

			<!-- auskommentiert wegen #298789
            <ng-container [ngTemplateOutlet]="duplicatesButtonTemplate" [ngTemplateOutletContext]="{row: row}"></ng-container>
            -->

			<!-- delete button -->
			<ng-container *ngIf="auth.hasAnyArray(moduleOptions.RIGHT_DELETE)">
                <img hisImage="hyphen" class="inlineicon treeAction hyphen">

				<button (click)="deleteRow(row)" hisImage="delete" class="icon" [disabled]="!row.get('canDelete')"
				    title="{{'common.deleteOf'|hisUi:row.get('Publication.title')}}"></button>
			</ng-container>
		</ng-template>

        <!-- Rechteabsicherung des Duplikats-Buttons muss _im_ Template passieren, da dieses auch an res-publication-search-result-list übergeben wird -->
        <!-- auskommentiert wegen #298789
        <ng-template #duplicatesButtonTemplate let-row="row">
             <res-publication-duplicates-button *ngIf="auth.hasAnyArray(moduleOptions.RIGHT_EDIT)"
                 [row]="row" prevPage="pubSearch">
             </res-publication-duplicates-button>
        </ng-template>
        -->
	</his-search-result>

	<!-- #266607 "Die richtige Publikation ist nicht dabei? ..." hier nur in Tabellenansicht anzeigen; in der Listenansicht gibt es ein eigenes -->
  	<ng-container *ngIf="!publicationService.showList && auth.hasAnyArray(moduleOptions.RIGHT_CREATE)">
        <div class="clearer"></div>
	    {{'fs.res.publication.search.notFoundQuestion' | hisUi}}<br/>
	    <a routerLink="/pub/create" hisImage="context_add" [queryParams]="{showSearchButton: true, showBackButton: false}">{{'fs.res.publication.search.create' | hisUi}}</a>
	</ng-container>
</div>
